module.exports = __webpack_public_path__ + "img/estelle-ribot.ffbbd7fa.jpg";